
    const original = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"20px\" height=\"20px\" viewBox=\"0 0 20 20\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch -->\n    <title>fill-solid-enabled</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"fill-solid-enabled\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-opacity=\"0.15\">\n        <rect id=\"Solid\" stroke=\"#000000\" fill=\"#855CD6\" x=\"0.5\" y=\"0.5\" width=\"19\" height=\"19\" rx=\"4\"></rect>\n    </g>\n</svg>\n";

    const getSRC = () => {
        const recolored = typeof Recolor === 'object' ? (
            original.replace(/#855cd6/gi, Recolor.primary)
        ) : original;
        return 'data:image/svg+xml;,' + encodeURIComponent(recolored);
    };

    export default getSRC;
